import { Form, RegistrationField, RegistrationFields } from "sharedTypes"

export type FormatRegistrationFieldsOptions = {
  /** When not `true`, omit WhatsApp opt-in row (same as `whatsappMessaging` flag). */
  whatsappMessaging?: boolean
}

export default (
  form: Form,
  enableNameAndEmailToggle?: boolean,
  options?: FormatRegistrationFieldsOptions,
): RegistrationFields => {
  const showWhatsappOptIn = options?.whatsappMessaging === true
  const {
    profilePhoneEnabled,
    profilePhoneRequired,
    profileCompanyEnabled,
    profileCompanyRequired,
    profileAddressEnabled,
    profileAddressRequired,
    profileCityEnabled,
    profileCityRequired,
    profileCountryEnabled,
    profileCountryRequired,
    profilePostalCodeEnabled,
    profilePostalCodeRequired,
    profileStateEnabled,
    profileStateRequired,
    profileTitleEnabled,
    profileTitleRequired,
    profileNameEnabled,
    profileEmailEnabled,
    profileBirthdateEnabled,
    profileBirthdateRequired,
    profileWhatsappOptInEnabled,
    translations: {
      fullName,
      emailAddress,
      phone,
      company,
      title,
      addressLine1,
      city,
      state,
      postalCode,
      country,
      birthdate,
    },
  } = form

  const personal: RegistrationField[] = [
    {
      name: fullName,
      enabled: profileNameEnabled,
      required: true,
      requiredLocked: true,
      fieldName: "profileName",
      readOnly: !enableNameAndEmailToggle,
    },
    {
      name: emailAddress,
      enabled: profileEmailEnabled,
      required: true,
      requiredLocked: true,
      fieldName: "profileEmail",
      readOnly: !enableNameAndEmailToggle,
    },
    {
      name: company,
      enabled: profileCompanyEnabled,
      required: profileCompanyRequired,
      fieldName: "profileCompany",
    },
    {
      name: title,
      enabled: profileTitleEnabled,
      required: profileTitleRequired,
      fieldName: "profileTitle",
    },
    {
      name: phone,
      enabled: profilePhoneEnabled,
      required: profilePhoneRequired,
      fieldName: "profilePhone",
    },
    ...(showWhatsappOptIn
      ? [{
        name: "WhatsApp Opt-In",
        enabled: profileWhatsappOptInEnabled ?? false,
        required: false,
        fieldName: "profileWhatsappOptIn",
        hideRequired: true,
      } satisfies RegistrationField]
      : []),
    {
      name: birthdate,
      enabled: profileBirthdateEnabled,
      required: profileBirthdateRequired,
      fieldName: "profileBirthdate",
    },
  ]

  const result: RegistrationFields = {
    personal,
    address: [
      {
        name: addressLine1,
        enabled: profileAddressEnabled,
        required: profileAddressRequired,
        fieldName: "profileAddress",
      },
      {
        name: city,
        enabled: profileCityEnabled,
        required: profileCityRequired,
        fieldName: "profileCity",
      },
      {
        name: state,
        enabled: profileStateEnabled,
        required: profileStateRequired,
        fieldName: "profileState",
      },
      {
        name: postalCode,
        enabled: profilePostalCodeEnabled,
        required: profilePostalCodeRequired,
        fieldName: "profilePostalCode",
      },
      {
        name: country,
        enabled: profileCountryEnabled,
        required: profileCountryRequired,
        select: true,
        fieldName: "profileCountry",
      },
    ],
  }

  return result
}
